import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam } from 'src/app/shared/models/Global-Search.model';

import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

import { SharedService } from '../../../shared/services/shared.service';
import { Router, ActivatedRoute,NavigationStart } from '@angular/router';
import { ApplicantRateChangeService} from '../../services/applicant-rate-change.service';
import * as fs from 'file-saver';
import { JwtService } from 'src/app/auth/services';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { DatePipe } from '@angular/common';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { User} from '../../../auth/models';
import { IRateAmendmentDocAdd } from 'src/app/applicant/models';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
@Component({
  selector: 'app-rate-change-request',
  templateUrl: './rate-change-request.component.html',
  styleUrls: ['./rate-change-request.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class RateChangeRequestComponent implements OnInit {
  isSearchLoading: boolean = false;
  showFilters:boolean;
  showSorting:boolean;
  rateHistoryDescriptionModal: boolean = false;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  matchModeOptionsForDropdown: SelectItem[];
  showAddRuleButtonCON:boolean = false;
  showAddRuleButtonMON:boolean = false;
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  searchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  vcaSearchSpinner = 'vcaSearchSpinner';
  rateChangeRequestList: any;
  selectRateChangeRequestList:any = [];
  startSearch: boolean = false;
  dialogPosition = 'topright';
  isVcaAdd : boolean = false;
  vcaForm:FormGroup;
  vendorCompanyList: any;
  clientCompanyList: any;
  loading: boolean = false;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="";
  selectedStatus:any;
  displayModal:boolean = false;
  displayNotesHistoryModal:boolean =false;
  displayNotesDescriptionModal:boolean = false; 
  notesList;
  assignId;
  companyId;
  clientId;
  notesFormControl = new FormControl("",[Validators.required, this.editorMaxLength(5000)]);
  rateApprovalUsersList: ILookupCategory[];
  selectedApprovalStatus:any;
  public selectedApprovalStatusId:Array<any> = [];
  arrApprovalStatus:any;
  approvalStatusId: any;
  itemsForReject: MenuItem[];
  isheaderCheckbokChecked: boolean = false;
  selectAllCount = 0;
  loggedInUserProfile: User;
  applicantRateHistoryList: any;
  
  applicantAdminRateHistoryModal: boolean = false;

  msaStatus:any;
  selectedMSAStatus:any;
  public selectedMSAStatusId:Array<any> = [];

  poStatus:any;
  selectedPOStatus:any;
  public selectedPOStatusId:Array<any> = [];
  
  msaFileDocUrl:string="";
  poFileDocUrl:string="";
  documentSearchValues:any;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value:'checkbox', header: 'Checkbox' },   
    { value: 'applicantName', header: 'Applicant' },
    { value: 'vendorCompanyName', header: 'Vendor' },
    { value: 'clientCompanyName', header: 'Client' },
    { value: 'currentBillRate', header: 'New Rate' },
    { value: 'startDateCurrentBillRate', header: 'Start Date of New Rate' },
    { value: 'serviceAgreementDate', header: 'Service Agreement Date' },
    { value: 'po', header: 'PO' },
    { value: 'msa', header: 'MSA' },
    { value: 'oldBillRate', header: 'Current Rate' },
    { value: 'startDateOldBillRate', header: 'Start Date of Current Rate' },
    { value: 'endDateOldBillRate', header: 'End Date of Current Rate' },
    { value: 'approvalStatusName', header: 'Rate Approval Status' },

    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' } ,
    { value: 'description', header: 'Description' }  
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value:'checkbox', header: 'Checkbox' },      
    { value: 'applicantName', header: 'Applicant' },
    { value: 'vendorCompanyName', header: 'Vendor' },
    { value: 'clientCompanyName', header: 'Client' },
    { value: 'currentBillRate', header: 'New Rate' },
    { value: 'startDateCurrentBillRate', header: 'Start Date of New Rate' },
    { value: 'serviceAgreementDate', header: 'Service Agreement Date' },
    { value: 'po', header: 'PO' },
    { value: 'msa', header: 'MSA' },
    { value: 'oldBillRate', header: 'Current Rate' },
    { value: 'startDateOldBillRate', header: 'Start Date of Current Rate' },
    { value: 'endDateOldBillRate', header: 'End Date of Current Rate' },
    { value: 'approvalStatusName', header: 'Rate Approval Status' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' } ,
    { value: 'description', header: 'Description' }   
    ];
    isUploadCompleted = false;
    rejectDialog: boolean = false;
    rejectReasonControl = new FormControl("", [Validators.required, this.editorMaxLength(5000)]);
    rejectModules = {
      toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['link', 'image']
      ], imageUploader: {
        upload: (file) => {
          return new Promise((resolve, reject) => {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
              if (file.size < 2097152) {
                this.isUploadCompleted = true;
                this.sharedService.uploadEditorImage(file).then(res => {
                  this.isUploadCompleted = false;
                  resolve(VMSConstants.editiorImageBaseUrl + res.substring(1));
                }).catch(err => {
                  reject(err);
                })
              } else {
                reject('Size too large');
              }
            }
            else {
              reject('Unsupported type');
            }
          });
        },
      },
    };

    showValidationErrorMessage = false;
    validationErrorMessage = '';
    RejectRateChangeDescriptionModal: boolean = false;
    showAddRuleButtonSNR = false;
    showAddRuleButtonSCR = false;
    showAddRuleButtonECR = false;
    showAddRuleButtonSAD = false;
    rateChangeStatus = [];
    selectedRateChangeStatus = [];
    poPreview:any;
    msaPreview:any;
    // status = [
    //   {id:'All', description: 'All'},
    //   {id:'Approved', description: 'Approved'},
    //   {id:'Rejected', description: 'Rejected'},
    //   {id:'Change Request', description: 'Change Request'}
    // ]
    @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,    
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private applicantRateChangeService:ApplicantRateChangeService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router,
    private jwtService:JwtService,
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
   
    // _router.events.forEach((event) => {
    //   if (event instanceof NavigationStart) {
    //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
         
    //      }
    //      else {
    //       var isTokenAvailable = this.sharedService.isTokenAvailable();
         
    //       if(isTokenAvailable){
    //       setInterval(() =>  this.checkSessionTimeout(), 60000);
    //       }        
    //      }
    //     }
    // });
    

  this.itemsForReject=[
     {
       label:'Rejection Notes',
       icon:'pi pi-comments',
     command: e => this.viewRejectionNotes(this.selectedGridMenuItem.description, this.selectedGridMenuItem.approvalStatusName,this.selectedGridMenuItem.invoiceEligibleApplicantId,this.selectedGridMenuItem.approvalStatusId)
      },
      {
          label:'Rate History',
          icon:'pi pi-eye',
          command: e => this.getApplicantRateHistoryBySuperAdminId(this.selectedGridMenuItem.companyId,this.selectedGridMenuItem.applicantReferenceId),
         },
  ];
  }
  checkSessionTimeout()
  {

    var isTokenAvailable = this.sharedService.isTokenAvailable();
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
     // console.log('Session' + result);
       if(!result) {
        if(this.poPreview != undefined)
        {
          this.poPreview.close();
        }
       if( this.msaPreview!=undefined)
       {
        this.msaPreview.close();
       }
         localStorage.removeItem('VMS');
         this._router.navigateByUrl('/login');
       }
    }
   
  }

  selectAllRow(headerCheckbok) {
    this.selectRateChangeRequestList = [];
    this.isheaderCheckbokChecked = headerCheckbok.checked;
    if (headerCheckbok.checked) {
      this.rateChangeRequestList.forEach(element => {
        if (element.statusName != 'Rejected' ) {
          element.isCheckboxChecked = true;
          this.selectRateChangeRequestList.push(element);
        }
      });
    } else {
      this.rateChangeRequestList.forEach(element => {
        element.isCheckboxChecked = false;
      });
    }
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.checkRateApprovalUser();
    this.getLoggedInUserProfile();
    this.getRateChangeStatus();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    this.matchModeOptionsForDropdown = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
    ];

    this.filterCondition=[
      {fieldName:"applicantName",type:"basic"},
      {fieldName:"vendorCompanyName",type:"basic"},
      { fieldName: "clientCompanyName", type:"basic" },
      {fieldName:"approvalStatusName",type:"customdropdown"},
      {fieldName:"createdByName",type:"basic"},
      {fieldName:"createdOn",type:"date"},
      {fieldName:"modifiedByName",type:"basic"},
      {fieldName:"modifiedOn",type:"date"},
      {fieldName:"currentBillRate",type:"numeric"},
      {fieldName:"startDateCurrentBillRate",type:"date"},
      {fieldName:"oldBillRate",type:"numeric"},
      {fieldName:"startDateOldBillRate",type:"date"},
      {fieldName:"endDateOldBillRate",type:"date"},
      { fieldName: "serviceAgreementDate", type: "date" },
      { fieldName: "po", type: "dropdown" },
      { fieldName: "msa", type: "dropdown" },
     
    ];

    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" });
    this.getAllApplicantRateChangeRequest(); 
    this.documentSearchValues=['All','Yes','No'];
  }

  

  loadAllApplicantRateChangeRequest(event:LazyLoadEvent)
  {
    // console.log(event);
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getAllApplicantRateChangeRequest();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;

    if(this.filters["startDateCurrentBillRate"]!= undefined)
    {
    if(this.filters["startDateCurrentBillRate"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonSNR = true;
    }
    else{
      this.showAddRuleButtonSNR = false;
    }
    }

    if(this.filters["startDateOldBillRate"]!= undefined)
    {
    if(this.filters["startDateOldBillRate"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonSCR = true;
    }
    else{
      this.showAddRuleButtonSCR = false;
    }
    }

    if(this.filters["endDateOldBillRate"]!= undefined)
    {
    if(this.filters["endDateOldBillRate"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonECR = true;
    }
    else{
      this.showAddRuleButtonECR = false;
    }
    }

    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonCON = true;
    }
    else{
      this.showAddRuleButtonCON = false;
    }
    }
    if(this.filters["modifiedOn"]!= undefined)
    {
    if(this.filters["modifiedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonMON = true;
    }
    else{
      this.showAddRuleButtonMON = false;
    }
    }
    if(this.filters["serviceAgreementDate"]!= undefined)
    {
    if(this.filters["serviceAgreementDate"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonSAD = true;
    }
    else{
      this.showAddRuleButtonSAD = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
     // this.getAllApplicantRateChangeRequest()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  getAllApplicantRateChangeRequest(){
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vcaSearchSpinner);
    this.applicantRateChangeService.getAllApplicantRateChangeRequest(this.searchParam).subscribe(data => {
      console.log(data);
      this.appliedFilters = [];
      for(let i=0;i<data.length;i++)
    {
     if (data[i].description != null) {
       data[i].description =data[i].description.replace(/<[^>]+>/g, '');
       if(data[i].description =='')
       {
         data[i].description ='';
       }
     }
     else{
      data[i].description ='';
     }
    }
      this.rateChangeRequestList =data;
      this.rateChangeRequestList.forEach(element => {
          this.selectAllCount++
      });
      this.isshowpaginator=this.rateChangeRequestList.length>0?true:false;
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vcaSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.applyFilter();
    this.selectedStatus = '';
    this.selectedStatusId = undefined;
    this.selectedMSAStatus ="";
    this.selectedMSAStatusId = undefined;
    this.selectedPOStatus ="";
    this.selectedPOStatusId = undefined;
    this.selectedRateChangeStatus = [];
    // this.selectRateChangeRequestList = [];
    this.resetCheckboxChecked();

  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter(){
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "customdropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              if(this.filterCondition[i].fieldName != "All")
              {
                this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value.lookupOrder
              })}
            }
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
            if(this.filterCondition[i].fieldName != "All")
            {
              this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })}
          }
        }
      }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.searchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vcaSearchSpinner);
       this.applicantRateChangeService.getAllApplicantRateChangeRequest(this.searchParam).subscribe(data => {
        // console.log(data);
         this.appliedFilters = [];
         for(let i=0;i<data.length;i++)
         {
          if (data[i].description != null) {
            data[i].description =data[i].description.replace(/<[^>]+>/g, '');
            if(data[i].description =='')
            {
              data[i].description ='';
            }
          }
          else{
            data[i].description ='';
           }
         }
         this.rateChangeRequestList = data;
         this.rateChangeRequestList.forEach(element => {
           this.selectAllCount++
         });
         this.isshowpaginator=this.rateChangeRequestList.length>0?true:false;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.vcaSearchSpinner);
       }, error => {
         console.log(error);
       })
    }
  }
  selectTableRow(row) {
    // console.log(row);
     let tempselectedRateChangeRequestList = this.selectRateChangeRequestList;
     if (row.checked) {
       //check the value is exists in the selectedInvoiceList
       let checkValueExists = tempselectedRateChangeRequestList.some(item => item.applicantId == row.value.applicantId);
       //Add the value
       if (!checkValueExists) {
        tempselectedRateChangeRequestList.push(row.value);
       }
       this.selectRateChangeRequestList = tempselectedRateChangeRequestList;
     } else {
       this.selectRateChangeRequestList = [];
       //remove the value
       for (var i = 0; i < tempselectedRateChangeRequestList.length; i++) {
         if (row.value.applicantId != tempselectedRateChangeRequestList[i].applicantId) {
           this.selectRateChangeRequestList.push(tempselectedRateChangeRequestList[i]);
         }
       }
     }
 
     if (this.selectAllCount == this.selectRateChangeRequestList.length) {
       this.isheaderCheckbokChecked = true;
     } else {
       this.isheaderCheckbokChecked = false;
     }
 
   }
 
   resetCheckboxChecked() {
     this.selectRateChangeRequestList = [];
     this.isheaderCheckbokChecked = false;
     this.selectAllCount = 0;
   }
 

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

//  getStatusOnChange(event)
//  {
//   this.selectedStatusId = event.value;
//   this.selectedStatus=event.value.description;
//  }

//  clearStatus()
//  {
//   this.selectedStatus ="";
//   this.selectedStatusId = undefined;
//  }
 checkRateApprovalUser() {
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.RateApprovalUsers).subscribe((data: any) => {
  this.rateApprovalUsersList = data;
 // console.log(this.rateApprovalUsersList);
 // console.log( this.loggedInUserProfile.sub);
 // console.log(this.rateApprovalUsersList.description.indexOf(this.loggedInUserProfile.sub));
  var tmprateApprovalUsers = this.rateApprovalUsersList.findIndex(t=>t.description==this.loggedInUserProfile.sub);
  if(tmprateApprovalUsers<0) {
    this._router.navigateByUrl('/dashboard/admin');
  }
 // console.log(tmprateApprovalUsers);
});
}

  getRateChangeStatus() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.RateChangeRequestStatus).subscribe((data: any) => {
      this.rateChangeStatus = data;
      this.arrApprovalStatus = this.rateChangeStatus;
      this.arrApprovalStatus.push({
        categoryId: 0, createdBy: 0, createdByUser: null, createdOn: null, description: "All", isActive: true,
        lookupCategory: null,
        lookupId: 0,
        lookupOrder: 0,
        modifiedBy: 0,
        modifiedByUser: null,
        modifiedOn: null
      });
      this.arrApprovalStatus.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.rateChangeStatus = this.arrApprovalStatus;
    });
  }
getLoggedInUserProfile() {
  this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
}

 

editorMaxLength(maxlength): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var regex = /(<([^>]+)>)/ig;
    var value = control.value;
    if (value == null) {
      return null;
    }
    var result = value.replace(regex, "");
    if (result.length > maxlength) {
      return { 'maxlengthError': true };
    } else {
      return null;
    }
  }
}

  approve() {
    var validatedResult = this.validateStatus(this.selectRateChangeRequestList, 'Approved');
    if (validatedResult == false) {
      this.showValidationErrorMessage = true;
      this.validationErrorMessage = 'Only Change Request can be changed to approved status';
    }
    else if (this.selectRateChangeRequestList.length > 0) {
      this.confirmationService.confirm({
        message: ' Would you like to change the status of the selected rate change request(s) to approved?',
        header: 'Approve',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.approveConfirm();
        },
        reject: (type) => {
          this.selectRateChangeRequestList = [];
          this.rateChangeRequestList.forEach(element => {
            element.isCheckboxChecked = false;
          });
        }
      });
    } else {
      this.selectRateChangeRequestList = [];
      this.rateChangeRequestList.forEach(element => {
        element.isCheckboxChecked = false;
      });
    }
  }

  validateStatus(selectedList, status) {
   // console.log(selectedList);
    for (let i = 0; i < selectedList.length; i++) {
     // console.log(selectedList[i].approvalStatusName);
      if (selectedList[i].approvalStatusName == 'Rejected' || selectedList[i].approvalStatusName == 'Approved') {
    //  if (selectedList[i].approvalStatusName == status) {
    //  console.log(selectedList);
        return false;
      }
    }
    return true;
  }

  validationErrorOk() {
    this.showValidationErrorMessage = false;
  }

  approveConfirm(){
    let value = {
      invoiceEligibleApplicantsSearch : this.selectRateChangeRequestList,
      notes: null,
      additionalNotes: null,
      isActive: true,
        createdBy: Number(this.loggedInUserProfile.uid),
        createdOn: null,
        modifiedBy: Number(this.loggedInUserProfile.uid),
        modifiedOn: new Date(),
    }
    const rateAmendmentDocAdd:IRateAmendmentDocAdd={
      invoiceEligibleApplicantId:this.selectRateChangeRequestList.invoiceEligibleApplicantId,
      applicantId:this.selectRateChangeRequestList.applicantId,
      applicantReferenceId:this.selectRateChangeRequestList.applicantReferenceId,
      engagementId:this.selectRateChangeRequestList.engagementId,
      engagementReferenceId:this.selectRateChangeRequestList.engagementReferenceId,
      submissionId:this.selectRateChangeRequestList.submissionId,
      submissionReferenceId:this.selectRateChangeRequestList.submissionReferenceId,
      vendorCompanyId:this.selectRateChangeRequestList.vendorCompanyId,
      clientCompanyId:this.selectRateChangeRequestList.clientCompanyId,
      requisitionId:this.selectRateChangeRequestList.requisitionId,
      tpsReferenceId:this.selectRateChangeRequestList.tpsReferenceId,
      newBillRate:this.selectRateChangeRequestList.currentBillRate,
      startDateNewBillRate:this.selectRateChangeRequestList.startDateCurrentBillRate,
      oldBillRate:this.selectRateChangeRequestList.startDateOldBillRate,
      hasGeneratedByAdmin:true,
      isActive:true,
      createdBy: Number(this.loggedInUserProfile.uid),
      createdOn:new Date(),
      modifiedBy: Number(this.loggedInUserProfile.uid),
      modifiedOn:new Date(),
     };
    this.applicantRateChangeService.approve(value).subscribe({
      next: (data) => {
        this.selectRateChangeRequestList = [];
        this.applyFilter();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Applicant rate approved.' });
        this.loading = false;
        this.spinner.hide();
        this.applicantRateChangeService.submitApplicantRateAmendment(rateAmendmentDocAdd).subscribe((data: any) => {
        });

      },
      error: (err) => {
        console.log(err)
      }      
    })
  }

  reject(){
    var validatedResult = this.validateStatus(this.selectRateChangeRequestList, 'Rejected');
    if (validatedResult == false) {
      this.showValidationErrorMessage = true;
      this.validationErrorMessage = 'Only Change Request can be changed to Reject status';
    }else{
      this.rejectDialog = true;
    }
  }

  cancelRejectDialog() {
    this.rejectDialog = false;
    this.selectRateChangeRequestList = [];
    //un select / un checked all the selected rows
    this.rateChangeRequestList.forEach(element => {
      element.isCheckboxChecked = false;
    });
    this.rejectReasonControl.setValue('');
  }

  submitRejectDialog(){
    this.confirmationService.confirm({
      message: ' Would you like to change the status of the selected  rate change request(s) to rejected?',
      header: 'Reject',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //this.rejectInvoiceConfirm(this.selectedInvoiceList);
        this.rejectConfirm();
      },
      reject: (type) => {
        this.rejectDialog = false;
        this.selectRateChangeRequestList = [];
        //un select / un checked all the selected rows
        this.rateChangeRequestList.forEach(element => {
          element.isCheckboxChecked = false;
        });
        this.rejectReasonControl.setValue('');
      }
    });
  }

  rejectConfirm(){
    let value = {
      invoiceEligibleApplicantsSearch : this.selectRateChangeRequestList,
      notes: this.rejectReasonControl.value,
      additionalNotes: null,
      isActive: true,
        createdBy: Number(this.loggedInUserProfile.uid),
        createdOn: new Date(),
        modifiedBy: Number(this.loggedInUserProfile.uid),
        modifiedOn: new Date(),
    }
    this.rejectDialog = false;
    this.applicantRateChangeService.reject(value).subscribe({
      next: (data) => {
        this.rejectReasonControl.setValue('');
        this.selectRateChangeRequestList = [];
        this.applyFilter();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'The selected rate change request(s) has been successfully updated to rejected status.' });
        this.loading = false;
        this.spinner.hide();
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }

  currencyFormat(Rate : number) : string {
    if(Rate == null){
      return "";
    }else{
      return '$' + Rate.toFixed(2);
    }
  }
  
  viewRejectionNotes(description,approvalStatusName,invoiceEligibleApplicantId,approvalStatusId) {
    this.applicantRateChangeService.getRejectionNotes(invoiceEligibleApplicantId,approvalStatusId).subscribe((data: any) => {
      this.RejectRateChangeDescriptionModal = true;
      if (approvalStatusName =='Rejected') {
      this.loadRejectedViewDescription(data.notes);
      }
      else {
        description = 'No Rejection Notes Available';
        this.loadRejectedViewDescription(description);
      }
    });
   
  }
  @ViewChild('RejectRateViewDescriptionContainer') RejectRateViewDescriptionContainer: ElementRef;
  loadRejectedViewDescription(data) {
    this.RejectRateViewDescriptionContainer.nativeElement.innerHTML = data;
  }

  getStatusOnChange(event) {
    this.selectedStatus = event.value.description;
    this.selectedStatusId = event.value.lookupOrder;
    this.selectedRateChangeStatus = event.value;
  }

  viewRateHistoryNotes(notes) {
    this.rateHistoryDescriptionModal = true;
    this.loadRateViewDescription(notes);
  }
  @ViewChild('rateViewDescriptionContainer') rateViewDescriptionContainer: ElementRef;
  loadRateViewDescription(data) {
    this.rateViewDescriptionContainer.nativeElement.innerHTML = data;
  }

  getApplicantRateHistoryBySuperAdminId(companyId: number,applicantTpsId: string)
{
  this.applicantAdminRateHistoryModal = true;
  this.applicantRateHistoryList =[];
  let uid = Number(this.loggedInUserProfile.uid);
  
  // this.applicantRateChangeService.GetApplicantBillRateChangeRequestHistory(companyId,applicantTpsId,uid).subscribe((data:any)=> {
  //   console.log(data);
  //   this.applicantRateHistoryList = data;
  // });

  this.applicantRateChangeService.GetApplicantBillRateChangeHistoryForVendor(applicantTpsId,uid).subscribe((data:any)=> {
   // console.log(data);
    for(let i=0;i<data.length;i++)
    {
     if (data[i].notes != null) {
       data[i].notes =data[i].notes.replace(/<[^>]+>/g, '');
       if(data[i].notes =='')
       {
         data[i].notes ='';
       }
     }
    }
    this.applicantRateHistoryList = data;
  });
 
}
getMSAStatusOnChange(event)
{
  this.selectedMSAStatusId = event.value;
  this.selectedMSAStatus=event.value;
 }

 clearMSAStatus()
 {
  this.selectedMSAStatus ="";
  this.selectedMSAStatusId = undefined;
 }

 getPOStatusOnChange(event)
{
  this.selectedPOStatusId = event.value;
  this.selectedPOStatus=event.value;
 }

 clearPOStatus()
 {
  this.selectedPOStatus ="";
  this.selectedPOStatusId = undefined;
 }
 ShowPOUploadFile(fileName) {
  this.poFileDocUrl=VMSConstants.applicantDocumentBaseUrl+fileName;
  
    this.poPreview = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.poFileDocUrl,
        title: 'PO Preview',
        fileName: this.poFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
}
ShowMSAUploadedFile(fileName) {
  if(fileName.includes("CompanyDocument")==true)
  {
    this.msaFileDocUrl=VMSConstants.companyDocumentBaseUrl+fileName;
  }
 else{
  this.msaFileDocUrl=VMSConstants.registrationDocumentBaseUrl+fileName;
 }
    this.msaPreview = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.msaFileDocUrl,
        title: 'MSA Preview',
        fileName: this.msaFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
}
clearRateApprovalStatus()
 {
  this.selectedStatus = '';
  this.selectedStatusId = undefined;
  this.selectedRateChangeStatus = [];

 }
}